<mat-accordion [formGroup]="optionsForm">


  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Display Options
      </mat-panel-title>
      <!-- <mat-panel-description>
        Description
      </mat-panel-description> -->

    </mat-expansion-panel-header>
    <ng-container [formGroupName]="'displayOptions'">
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'product'" (change)="onChangeDisplayOptionsFn($event)">Product</mat-checkbox>
      </div>
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox"[formControlName]="'service'"  (change)="onChangeDisplayOptionsFn($event)">Service</mat-checkbox>
      </div>
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'labour'"  (change)="onChangeDisplayOptionsFn($event)">Labor</mat-checkbox>
      </div>
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'shipping'"  (change)="onChangeDisplayOptionsFn($event)">Shipping</mat-checkbox>
      </div>
<!--      <div class="col-12 mb-2">-->
<!--        <mat-checkbox class="example-margin" [formControlName]="'unitSellingPrice'"  (change)="onChangeDisplayOptionsFn($event)">Unit Selling Price</mat-checkbox>-->
<!--      </div>-->
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'signature'"  (change)="onChangeDisplayOptionsFn($event)">Signature</mat-checkbox>
      </div>
<!--      <div class="col-12 mb-2">-->
<!--        <mat-checkbox class="example-margin" [formControlName]="'totalPrice'"  (change)="onChangeDisplayOptionsFn($event)">Total Price</mat-checkbox>-->
<!--      </div>-->
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'providedServices'"  (change)="onChangeDisplayOptionsFn($event)">Provided Services</mat-checkbox>
      </div>
<!--      <div class="col-12 mb-2">-->
<!--        <mat-checkbox class="example-margin" [formControlName]="'tax'"  (change)="onChangeDisplayOptionsFn($event)">Tax</mat-checkbox>-->
<!--      </div>-->
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'qualifyingNotes'"  (change)="onChangeDisplayOptionsFn($event)">Qualifying Notes</mat-checkbox>
      </div>
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'scopeNotes'"  (change)="onChangeDisplayOptionsFn($event)" >Scope Notes</mat-checkbox>
      </div>


      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'approvedQuantity'"  (change)="onChangeDisplayOptionsFn($event)" >Approved Quantity</mat-checkbox>
      </div>
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'rejectedQuantity'"  (change)="onChangeDisplayOptionsFn($event)" >Rejected Quantity</mat-checkbox>
      </div>
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'productSpecificationSheet'"  (change)="onChangeDisplayOptionsFn($event)" >Product Specification Sheet</mat-checkbox>
      </div>
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'productWarrantySheet'"  (change)="onChangeDisplayOptionsFn($event)" >Product Warranty Sheet</mat-checkbox>
      </div>
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'serviceSpecificationSheet'"  (change)="onChangeDisplayOptionsFn($event)" >Service Specification Sheet</mat-checkbox>
      </div>
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'serviceWarrantySheet'"  (change)="onChangeDisplayOptionsFn($event)" >Service Warranty Sheet</mat-checkbox>
      </div>
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'vendorWarrantySheet'"  (change)="onChangeDisplayOptionsFn($event)" >Vendor Product Warranty Sheet</mat-checkbox>
      </div>
      <div class="col-12 mb-2">
        <mat-checkbox class="example-margin bidone-checkbox" [formControlName]="'confirmColorSelection'"  (change)="onChangeDisplayOptionsFn($event)" >Confirm Color Selection</mat-checkbox>
      </div>
    </ng-container>
  </mat-expansion-panel>


</mat-accordion>
